export var ProgrammaticCampaignEngagementBreakdownAttributionMethod;
(function (ProgrammaticCampaignEngagementBreakdownAttributionMethod) {
    ProgrammaticCampaignEngagementBreakdownAttributionMethod["NOT_ATTRIBUTED"] = "Not Attributed";
    ProgrammaticCampaignEngagementBreakdownAttributionMethod["VIEW_THROUGH"] = "View-Through";
    ProgrammaticCampaignEngagementBreakdownAttributionMethod["CLICK_THROUGH"] = "Click-Through";
})(ProgrammaticCampaignEngagementBreakdownAttributionMethod || (ProgrammaticCampaignEngagementBreakdownAttributionMethod = {}));
export var IntegratedCampaignReportReached;
(function (IntegratedCampaignReportReached) {
    IntegratedCampaignReportReached[IntegratedCampaignReportReached["AccountsWithoutImpressions"] = 0] = "AccountsWithoutImpressions";
    IntegratedCampaignReportReached[IntegratedCampaignReportReached["AccountsReached"] = 1] = "AccountsReached";
})(IntegratedCampaignReportReached || (IntegratedCampaignReportReached = {}));
//# sourceMappingURL=ProgrammaticCampaigns.js.map